import React from 'react';
import PropTypes from 'prop-types';

import withStyles from '@mui/styles/withStyles';
import Tooltip from '@mui/material/Tooltip';

import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import DirectionsIcon from '@mui/icons-material/Directions';
import ClickAwayListener from '@mui/material/ClickAwayListener';


import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';


import { grey } from '@mui/material/colors';


const styles = theme => ({
    tooltip: {
        background: theme.palette.common.white,
        color: theme.palette.text.primary,
        boxShadow: theme.shadows[6],
        fontSize: 11,
        padding: 10,
        maxWidth: '100%'
    },
    popper: {
        opacity: 1,
        '&[x-placement*="right"] $arrowArrow': {
            left: 0,
            marginLeft: '-1em',
            height: '3em',
            width: '1em',
            '&::before': {
                borderWidth: '1em 1em 1em 0',
                borderColor: `transparent ${theme.palette.common.white} transparent transparent`
            }
        },
        pointerEvents: 'auto'
    },
    arrowArrow: {
        position: 'absolute',
        fontSize: 7,
        width: '3em',
        height: '3em',
        '&::before': {
            content: '""',
            margin: 'auto',
            display: 'block',
            width: 0,
            height: 0,
            borderStyle: 'solid'
        }
    },
    button: {
        marginTop: 10,
        marginLeft: 15,
        marginBottom: theme.spacing(1)
    },
    input: {
        '-moz-appearance': 'textfield'
    },



    listItem: {
        paddingLeft: '12px',


        '&:hover': {
            background: grey[200]
        }
    },

    listItemText: {
        whiteSpace: 'nowrap',
        paddingLeft: '0px'
    },
    iconButton: {
    }



});

class ReclamationTooltip extends React.Component {

    handleKeyDown = (event) => {
        if (event.key === 'Enter')
            this.props.onSearch();
    };

    renderTitle() {
        const { classes, onClose, numeroReclamation, onChange, onSearch, error } = this.props;

        return (
            <ClickAwayListener onClickAway={onClose}>
                <div>
                    <Typography variant="subtitle1" gutterBottom>Accèder à un dossier après-vente</Typography>
                    <TextField
                        type="text"
                        name="numeroReclamation"
                        value={numeroReclamation}
                        onChange={onChange}
                        onKeyDown={this.handleKeyDown}
                        label="Numéro de dossier"
                        InputLabelProps={{ shrink: true }}
                        inputProps={{
                            className: classes.input
                        }}
                        autoFocus
                    />
                    <Button className={classes.button} variant="contained" size="small" color="secondary" onClick={onSearch} disabled={!numeroReclamation || !!error}>
                        Voir
                    </Button>
                    <span className={classes.arrowArrow} />
                    {error && <Typography color="error">{error}</Typography>}
                </div>
            </ClickAwayListener>
        );
    }

    render() {
        const { classes, open, onClose, onOpen, expanded } = this.props;

        return (

            <Tooltip
                classes={{ tooltip: classes.tooltip, popper: classes.popper }}
                disableFocusListener
                disableHoverListener
                disableTouchListener
                open={open}
                onClose={onClose}
                placement="right"
                title={this.renderTitle()}
            >

                <ListItem className={classes.listItem} onClick={onOpen}>

                    <ListItemIcon className={classes.iconButton}>
                        <DirectionsIcon />
                    </ListItemIcon>

                    {expanded && (
                        <ListItemText
                            className={classes.listItemText}
                            primary="Accès rapide"
                        />
                    )}
                </ListItem>


            </Tooltip>

        );
    }
}

ReclamationTooltip.propTypes = {
    classes: PropTypes.object.isRequired,

    numeroReclamation: PropTypes.string.isRequired,
    open: PropTypes.bool.isRequired,
    error: PropTypes.string,

    onChange: PropTypes.func.isRequired,
    onSearch: PropTypes.func.isRequired,
    onOpen: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired
};

export default withStyles(styles)(ReclamationTooltip);